function getInitialState() {
  return { counts: {} };
}

// eslint-disable-next-line no-unused-vars
export default function manageReducer(state = getInitialState(), { type, payload }) {
  return state;
}
